<template>
    <AppForm class="pl-3 pr-3" v-if="toolUserSettings" ref="changeSettingsForm">
        <v-card-title v-if="utils.getPlatform() === $const.PLATFORM_TRADEBALL" class="pt-2 pl-3 pb-0">
            <span :class="$vuetify.theme.dark ? 'lightGreyText' : 'lightBlackText'" class="font-weight-regular font16">
                {{ $t('menu.settings') }}
            </span>
        </v-card-title>
        <v-card-text v-if="utils.getPlatform() === $const.PLATFORM_TRADEBALL">
            <v-container class="pl-0 pr-0 text-center">
                <v-row>
                    <v-col cols="6" class="px-2 pt-0 pb-0">
                        <v-switch
                            color="tbGreen"
                            class="mt-1"
                            v-model="toolUserSettings.is_show_credit"
                            :label="$t('menu.showCredit')"
                            hide-details
                            :ripple="false"
                            @change="changeSettings"
                        ></v-switch>
                    </v-col>
                    <v-col cols="6" class="px-2 pt-0 pb-0">
                        <v-switch
                            color="tbGreen"
                            class="mt-1"
                            v-model="toolUserSettings.is_show_balance"
                            :label="$t('menu.showBalance')"
                            hide-details
                            :ripple="false"
                            @change="changeSettings"
                        ></v-switch>
                    </v-col>
                    <v-col cols="12" class="px-2 pt-0 pb-0">
                        <v-switch
                            color="tbGreen"
                            class="mt-3"
                            v-model="toolUserSettings.is_show_exposure"
                            :label="$t('menu.showExposure')"
                            hide-details
                            :ripple="false"
                            @change="changeSettings"
                        ></v-switch>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-card-title class="pt-2 pl-3 pb-0">
            <span :class="$vuetify.theme.dark ? 'lightGreyText' : 'lightBlackText'" class="font-weight-regular font16">
                {{ $t('menu.betNotifications') }}
            </span>
        </v-card-title>
        <v-card-text>
            <v-container class="pl-0 pr-0 text-center">
                <v-row>
                    <v-col cols="6" class="px-2 pt-0 pb-0">
                        <v-switch
                            color="tbGreen"
                            class="mt-1"
                            v-model="toolUserSettings.is_play_sound_on_bet"
                            :label="$t('menu.playSoundOnBet')"
                            hide-details
                            :ripple="false"
                            @change="changeSettings"
                        ></v-switch>
                    </v-col>
                    <v-col cols="6" class="px-2 pt-0 pb-0">
                        <v-switch
                            color="tbGreen"
                            class="mt-1"
                            v-model="toolUserSettings.is_show_popup_on_bet"
                            :label="$t('menu.showPopUpOnBet')"
                            hide-details
                            :ripple="false"
                            @change="changeSettings"
                        ></v-switch>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </AppForm>
</template>
<style scoped></style>
<script>
    import AppForm from 'Pages/core/form/AppForm';

    export default {
        name: 'app-menuAccountChangeSettings',
        components: {
            AppForm,
        },
        data() {
            return {};
        },

        created: function () {
            console.log('Component %s was created.', this.$options.name);
        },

        mounted() {
            console.log('Component %s mounted.', this.$options.name);
        },

        methods: {
            changeSettings() {
                this.$store.dispatch('UserModule/changeSettings', {
                    toolUserSettings: this.toolUserSettings,
                });
            },
        },

        computed: {
            toolUserSettings: {
                get() {
                    return this.$store.getters['AppModule/getToolUserSettings'];
                },
                set(value) {
                    this.$store.commit('AppModule/setToolUserSettings', value);
                },
            },
        },
    };
</script>
